// @ts-nocheck
import { SupportedLanguages } from '../constants/general';

const supportedLanguageByValue = {
  en: SupportedLanguages.English,
  english: SupportedLanguages.English,
  es: SupportedLanguages.Spanish,
  spanish: SupportedLanguages.Spanish,
};

export function normalizePreferredLanguage(value?: string | null) {
  return supportedLanguageByValue[value?.toLowerCase() ?? ''] ?? SupportedLanguages.English;
}

export function recognizedSupportedLanguage(value?: string | null): SupportedLanguages | undefined {
  if (!value) return undefined;
  return supportedLanguageByValue[value.toLowerCase()];
}

export function normalizeSupportedLanguages(values?: string[] | null) {
  const normalizedValues = (values ?? [])
    .map((value) => supportedLanguageByValue[value.toLowerCase()])
    .filter((value): value is SupportedLanguages => Boolean(value));

  if (!normalizedValues.includes(SupportedLanguages.English)) {
    normalizedValues.push(SupportedLanguages.English);
  }

  return [...new Set(normalizedValues)];
}

export function recognizedSupportedLanguages(
  values?: string[] | null,
): SupportedLanguages[] | undefined {
  if (!values?.length) return undefined;

  const recognized: SupportedLanguages[] = [];
  for (const value of values) {
    const language = recognizedSupportedLanguage(value);
    // An unrecognized entry would be filtered out; keep the stored list intact.
    if (!language) return undefined;
    recognized.push(language);
  }

  return [...new Set(recognized)];
}
